import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const userProductCountApi = factory.get("userProductCount");

const initialState = {
  searchBody: {},
  userProductCounts: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const userProductCountSlice = createSlice({
  name: "userProductCount",
  initialState,
  reducers: {
    setDataTable: (state, { payload }) => {
      state.userProductCounts.data = payload.data.data;
      state.userProductCounts.total = payload.data.total;
    },
    setLoading: (state, action) => {
      state.userProductCounts.loading = !state.userProductCounts.loading;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const { setLoading, setDataTable, setSearchBody } =
  userProductCountSlice.actions;

export default userProductCountSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await userProductCountApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const UserProductCount = {
  getAll,
};
